module.exports = __webpack_public_path__ + "static/media/perfume.fd91126d.jpg";